export default {
  categories: null,
  categoryDetail: null
}
